import React from 'react'

function Hr() {
  return <hr className='eds-spacing--mt-16' />
}

export default Hr
